import { MaterialCommunityIcons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { Box, Button, HStack, Text, VStack } from "native-base";
import React, { useState } from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

import RoundedIcon from "@/components/atoms/RoundedIcon";
import RoundedLogo from "@/components/atoms/RoundedLogo";
import EmptyList from "@/components/molecules/EmptyList";
import Modal from "@/components/molecules/Modal";
import { useViewport } from "@/contexts/ViewportContext";
import { StoreType } from "@/interfaces/domain/StoreType";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

type StoreTypesListProps = {
  storeTyes: StoreType[];
  isLoading: boolean;
  onSelectType: (typeId: string) => void;
};

const StoreTypeItem = ({
  type,
  width,
  onPress,
}: {
  type: StoreType;
  width: number;
  onPress: () => void;
}) => (
  <GhostButton onPress={onPress}>
    <VStack w={width + "px"} justifyContent="center" alignItems="center" m="2" mx="2.5">
      <RoundedLogo logoUrl={type.foto_tipo} />
      <Text fontSize="md" bold color={"text.600"} mt="10px" isTruncated>
        {type.nome}
      </Text>
    </VStack>
  </GhostButton>
);

const StoreTypesList = ({ isLoading, onSelectType, storeTyes }: StoreTypesListProps) => {
  const { isWebMode } = useViewport();

  const [modalVisible, setModalVisible] = useState(false);

  const cardWidth = isWebMode ? 130 : 100;

  const firstItems = storeTyes?.slice(0, 5) || [];

  if (!storeTyes && !isLoading) {
    return <EmptyList />;
  }

  const onSelect = (typeId: string) => {
    setModalVisible(false);
    onSelectType(typeId);
  };

  return (
    <>
      <HStack flexWrap="wrap" justifyContent="space-between">
        {isLoading ? (
          <>
            {Array(6)
              .fill(1)
              .map((_, k) => (
                <Box key={k} alignItems="center" m="2" mx="2.5">
                  <ShimmerLgo />
                  <ShimmerPlaceholder
                    style={{
                      width: 90,
                    }}
                  />
                </Box>
              ))}
          </>
        ) : (
          <>
            {firstItems.map((type) => (
              <StoreTypeItem
                key={type._id}
                type={type}
                width={cardWidth}
                onPress={() => onSelect(type._id)}
              />
            ))}
            <GhostButton onPress={() => setModalVisible(true)}>
              <VStack
                w={cardWidth + "px"}
                justifyContent="center"
                alignItems="center"
                m="2"
                mx="2.5">
                <RoundedIcon
                  boxSize={isWebMode ? "24" : "20"}
                  iconSize={isWebMode ? "12" : "8"}
                  icon={<MaterialCommunityIcons name="chevron-down-circle" />}
                />
                <Text fontSize="md" bold color={"text.600"} mt="10px">
                  Ver mais
                </Text>
              </VStack>
            </GhostButton>
          </>
        )}
      </HStack>
      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        Header="Todas as Categorias"
        Body={
          <HStack pl="4" flexWrap="wrap" justifyContent="space-between">
            {storeTyes?.map((type) => (
              <StoreTypeItem
                key={type._id}
                type={type}
                width={cardWidth + 20}
                onPress={() => onSelect(type._id)}
              />
            ))}
          </HStack>
        }
      />
    </>
  );
};

const GhostButton = styled(Button).attrs({
  variant: "ghost",
  colorScheme: "light",
  m: 0,
  p: 0,
})``;

const ShimmerLgo = styled(ShimmerPlaceholder)`
  border-radius: 90px;
  width: 90px;
  height: 90px;
  margin: 10px;
`;

export default StoreTypesList;
